/* Memerle — bandeau défilant : transforme la barre d'annonce (1 message par ligne) en défilement continu */
(function () {
  function build() {
    var bar = document.querySelector('#memerle-topbar .announcement-bar') || document.querySelector('#memerle-header-wrapper .announcement-bar');
    if (!bar || bar.getAttribute('data-marquee')) return;
    var msgs = bar.innerHTML
      .split(/<br\s*\/?>/i)
      .map(function (s) {
        var t = document.createElement('div');
        t.innerHTML = s;
        return (t.textContent || '').trim();
      })
      .filter(Boolean)
      .filter(function (m) {
        /* Messages de Noël (« Noël : … » / « Christmas: … ») affichés seulement du 1er octobre au 25 décembre */
        if (!/^(no[eë]l|christmas)\b/i.test(m)) return true;
        var now = new Date();
        var mo = now.getMonth();
        return mo === 9 || mo === 10 || (mo === 11 && now.getDate() <= 25);
      });
    if (!msgs.length) return;

    bar.setAttribute('data-marquee', '1');
    bar.classList.add('memerle-marquee');
    bar.innerHTML = '';

    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = msgs.join(' · ');
    bar.appendChild(sr);

    var track = document.createElement('div');
    track.className = 'memerle-marquee__track';
    track.setAttribute('aria-hidden', 'true');
    for (var g = 0; g < 2; g++) {
      var ul = document.createElement('ul');
      ul.className = 'memerle-marquee__group';
      for (var r = 0; r < 3; r++) {
        msgs.forEach(function (m) {
          var li = document.createElement('li');
          li.textContent = m;
          ul.appendChild(li);
        });
      }
      track.appendChild(ul);
    }
    bar.appendChild(track);

    /* vitesse constante : ~45 px par seconde */
    var half = track.scrollWidth / 2;
    if (half > 0) track.style.animationDuration = Math.max(20, Math.round(half / 45)) + 's';

    /* Le bandeau est rendu hors du header fixe (sections/header.liquid) : il défile avec la page */
    if (!bar.closest('#memerle-topbar')) {
      var top = document.createElement('div');
      top.id = 'memerle-topbar';
      top.appendChild(bar);
      document.body.insertBefore(top, document.body.firstChild);
    }
    document.documentElement.classList.add('memerle-has-topbar');

    if (typeof window.setMemerleHeaderStackHeight === 'function') window.setMemerleHeaderStackHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();

/* Memerle — menu mobile : un clic sur le voile gris referme la carte */
document.addEventListener('click', function (e) {
  var w = document.getElementById('memerle-header-wrapper');
  if (!w || e.target !== w) return;
  var d = document.getElementById('Details-menu-drawer-container');
  if (d && d.hasAttribute('open')) {
    var s = d.querySelector('summary');
    if (s) s.click();
  }
});
